import {ApiError, NetworkError, apiFetch} from './api';
import {desktopBrands} from '../desktop-brands';

export type DesktopAuthorizationStatus='pending'|'approved'|'consumed'|'completed'|'cancelled'|'expired';
export interface DesktopAuthorization {
 request_id:string;
 brand_id:string;
 product_name:string;
 environment:'dev'|'test'|'prod';
 status:DesktopAuthorizationStatus;
 expires_at:string;
 return_uri:string;
}
const statuses=new Set(['pending','approved','consumed','completed','cancelled','expired']);
const env=(import.meta as {env?:Record<string,string|boolean|undefined>}).env??{};
const configuredEnvironment=env.VITE_SITE_ENVIRONMENT??(env.DEV?'dev':'prod');
const environment=configuredEnvironment==='production'?'prod':configuredEnvironment==='development'?'dev':configuredEnvironment;
export function desktopRequestID(search:string):string|null {
 const values=new URLSearchParams(search).getAll('request_id');
 return values.length===1&&/^[A-Za-z0-9_-]{16,128}$/.test(values[0])?values[0]:null;
}

export async function getDesktopAuthorization(requestID:string,signal?:AbortSignal):Promise<DesktopAuthorization> {
 const result=await apiFetch<DesktopAuthorization>(`/v1/auth/desktop/requests/${encodeURIComponent(requestID)}`,{signal});
 const brand=desktopBrands.find(brand=>brand.id===result.brand_id);
 let callback:URL;
 try{callback=new URL(result.return_uri)}catch{throw new NetworkError('登录请求无效，请从客户端重新发起。')}
 if(!brand||(brand.testOnly&&result.environment==='prod')||result.request_id!==requestID||typeof result.product_name!=='string'||!result.product_name.trim()||result.product_name.length>200||result.environment!==environment||!statuses.has(result.status)||!Number.isFinite(Date.parse(result.expires_at))
  ||callback.protocol!==`cn.sciland.auth.${brand.id}.${result.environment}:`||callback.hostname!=='login'||callback.pathname!=='/complete'
  ||callback.username||callback.password||callback.port||callback.hash||Array.from(callback.searchParams.keys()).length!==2
  ||callback.searchParams.get('request_id')!==requestID||!/^[A-Za-z0-9_-]{32,128}$/.test(callback.searchParams.get('state')??'')) {
  throw new NetworkError('登录请求无效，请从客户端重新发起。');
 }
 return result;
}

export function approveDesktopAuthorization(requestID:string,expectedSessionVersion:number,signal?:AbortSignal):Promise<{status:'approved'}> {
 return apiFetch(`/v1/auth/desktop/requests/${encodeURIComponent(requestID)}/approve`,{method:'POST',auth:true,refreshProof:true,expectedSessionVersion,signal});
}

export function describeDesktopAuthorizationError(error:unknown):string {
 if(error instanceof NetworkError)return error.message;
 if(error instanceof ApiError){
  if(error.code===4126)return '请先设置登录密码，再继续授权。';
  if(error.code===4128)return '登录请求已取消，请从客户端重新发起。';
  if(error.code===4125)return '此请求已由其他账号授权，请从客户端重新发起。';
  if(error.code===4124)return '网页登录凭据已失效，请重新登录。';
  if(error.status===404||error.status===410)return '登录请求已失效，请从客户端重新发起。';
  if(error.status===409)return '登录请求的状态已变化，请查看当前状态或从客户端重新发起。';
  if(error.status===401)return '网页登录已过期，请重新登录。';
  if(error.status===403)return '当前账号无法授权，请检查账号设置或换个账号。';
  if(error.status===429)return '操作过于频繁，请稍后重试。';
 }
 return '暂时无法完成授权，请稍后重试。';
}
